// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const baseUrl = `https:${window.location.origin.substring(window.location.protocol.length)}`;
console.info("App URL",baseUrl);
const fullUrl = `https:${window.location}`;
console.info('Full URL', fullUrl);
var MatchURl = fullUrl.match(/view-supplier/g);

if(baseUrl=="https://iaf-app.gke2.ope.gcp.renault.com" || baseUrl=="https://iaf-app.ope.apps.renault.com") {
	var motomoUrl= 'https://piwik.renault-digital.com/';
	var motomoUserId= 1581;
	var production= true;
	var environmentName= 'ope';
	var oAuthEnable = true;

} else if(baseUrl == 'https://iaf-app-ppd.int.apps.renault.com') {
	var motomoUrl= 'https://piwik.renault-digital.com/';
	var motomoUserId= 1579;
	var production= true;
	var environmentName= 're7';
	var oAuthEnable = true;

} else if(baseUrl == 'https://iaf-app.int.apps.renault.com/') {
	var issuer = 'https://idp2.renault.com/nidp/oauth/nam';
	var  loginUrl = 'https://idp2.renault.com/nidp/oauth/nam/authz';
	var  userinfoEndpoint = 'https://idp2.renault.com/nidp/oauth/nam/userinfo';
	var motomoUrl= 'https://piwik.renault-digital.com/';
	var motomoUserId= 1579;
	var production= true;
	var environmentName= 'qua';
	var oAuthEnable = true;

}else if(MatchURl != null){

	var motomoUrl= 'https://piwik.renault-digital.com/';
	var motomoUserId= 1580;
	var production= true;
	var environmentName= 'int';
	var oAuthEnable = false;
}else {

	var motomoUrl= "https://matomo.dt.renault.com/";
	var motomoUserId = 1580;
	var production= true;
	var environmentName= 'int';
	// var oAuthEnable = true;
}


export const environment = {
  production: false,
  allowedUrls: [ 'https://apis.renault.com','https://iaf-app.dev.apps.renault.com/','https://iaf-app.dev.apps.renault.com/','https://iaf-app.dev.apps.renault.com/view-supplier' ],
  // Matomo/Piwik settings
  matomoUrl: motomoUrl,
  matomoId: motomoUserId,
  envName : environmentName,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
